module.exports = __webpack_public_path__ + "img/Progress.1353991b.svg";